import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";
import Moment from "react-moment";
import { Fragment } from "react";
import { MdArrowRight } from "react-icons/md";
import DatePicker from "react-datepicker";
import cx from "../Portal.module.css";
import "react-datepicker/dist/react-datepicker.css";
import { httpPortal, sortByDateDescend } from "../../Apis/commonApis";
import {
  combineDateTime,
  formatDate,
  getFullName,
  getMondayDate,
  getMonthAgoDate,
} from "../../utils/CommonFunctions";
import JournalDetails from "./JournalDetails";

const calendarStrings = {
  lastDay: "[Yesterday ]",
  sameDay: "[Today ]",
  nextDay: "[Tomorrow ]",
  lastWeek: "L",
  nextWeek: "L",
  sameElse: "L",
};

const ClientJournalPortal = (props) => {
  const { clientData } = props;

  const [journalData, setJournalData] = useState([]);
  const [clientJournal, setClientJournal] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(0);

  const [filterType, setFilterType] = useState("custom");
  const [dateRange, setDateRange] = useState([getMonthAgoDate(), new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (clientData) {
      if (filterType === "custom" && endDate) {
        getJournalbyClientId(formatDate(startDate), formatDate(endDate));
      } else if (filterType === "week") {
        let mondayDate = getMondayDate(new Date());
        getJournalbyClientId(formatDate(mondayDate), formatDate(new Date()));
      } else if (filterType === "today") {
        getJournalbyClientId(formatDate(new Date()), formatDate(new Date()));
      }
    }
  }, [filterType, dateRange, refreshData, clientData]);

  const getJournalbyClientId = async (start, end) => {
    let client_id = localStorage.getItem("fandfData");
    client_id = JSON.parse(client_id);
    setLoading(true);
    const endpoint = `journal?clientId=${client_id?.clientId}&careHomeId=${client_id?.careHomeId}&startDate=${start}&endDate=${end}`;
    const res = await httpPortal(endpoint, "get", null, null);
    setLoading(false);
    if (res.status) {
      handleAgencyData(res);
    } else {
      setJournalData([]);
      setClientJournal({});
    }
  };

  function handleAgencyData(allData) {
    const shiftData = allData?.result;
    const taskData = allData?.tasks;
    let clientJournals = [];
    shiftData?.forEach((shift) => {
      if (shift) {
        const shiftTasks = taskData.filter(
          (item) => item.shiftDate?.split("T")[0] === shift.Date
        );
        const fandfRating = shift?.fanfRatings?.find(
          (item) => item.clientId === clientData?._id
        );
        clientJournals.push({
          shiftId: shift?.shiftId,
          _id: shift?._id,
          Date: shift?.Date ?? "",
          shiftDateTime: combineDateTime(
            shift.Date,
            shift.startingTime,
            shift.timeZone
          ),
          endDate: shift?.endDate ?? "",
          Task: shiftTasks ?? [],
          notesData: shift.notesData,
          forClient: getFullName(clientData),
          clientImage: clientData?.image,
          startingTime: shift?.startingTime ?? "",
          endingTime: shift?.endingTime ?? "",
          shiftTimeZone: shift.timeZone,
          careTeamId: shift?.careTeamId,
          checkinDateTime: shift?.checkinDateTime,
          checkoutDateTime: shift?.checkoutDateTime,
          fndfRating: fandfRating?.rating ?? 0,
          clientId: shift?.clientId,
          shiftApprovalstatus: shift?.shiftApprovalstatus ?? "",
          shiftEndDatetime: shift?.shiftEndDatetime ?? "",
          status: shift?.status ?? shift?.status,
          templateType: shift?.templateType ?? "",
          wellbeingAssessment: shift?.wellbeingAssessment ?? {},
        });
      }
    });

    if (clientJournals?.length > 0) {
      let sortedObj = sortByDateDescend(clientJournals, "shiftDateTime");
      let groupdate = groupJournalDataByDate(sortedObj);
      // let groupdate = groupItems(sortedObj, "Date");
      // groupdate = Object.entries(groupdate).map(([k, v]) => ({ [k]: v }));
      setJournalData(groupdate ?? []);
      setClientJournal(sortedObj[0] ?? {});
    } else {
      setJournalData([]);
      setClientJournal({});
    }
  }

  function customDateChangeHandler(daterange) {
    setDateRange(daterange);
  }

  const activeTab = {
    background: "#f0e8f7",
  };

  return (
    <>
      <div className={`row clientList ${cx.careJournalSection}`}>
        <h5>Shifts History</h5>
        <div className="shiftsHistory">
          <ul className="filter_box me-2 mb-1">
            <NavLink
              exact
              activeClassName={filterType === "today" ? "active" : ""}
              to="#"
              onClick={() => setFilterType("today")}
            >
              Today
            </NavLink>
            <NavLink
              activeClassName={filterType === "week" ? "active " : ""}
              to="#"
              onClick={() => setFilterType("week")}
            >
              This Week
            </NavLink>
            <NavLink
              activeClassName={filterType === "custom" ? "active" : ""}
              to="#"
              onClick={() => setFilterType("custom")}
            >
              Custom
            </NavLink>
            {filterType === "custom" && (
              <div className="datepicker_input">
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    customDateChangeHandler(update);
                  }}
                  isClearable={true}
                />
              </div>
            )}
          </ul>
        </div>
        <div className="col-md-6 journalListScroll mb-3 mb-md-2 mb-lg-2 mb-xl-2">
          <ul className={`menuList ${cx.careBox}`}>
            {loading && <p>Loading...</p>}

            {journalData?.length > 0 &&
              journalData?.map((journal, jIndex) => {
                return (
                  <Fragment key={jIndex}>
                    <h5 className="titlen">
                      <span style={{ color: "#BB6BD9" }}>
                        <Moment calendar={calendarStrings}>
                          {journal.date}
                        </Moment>
                      </span>{" "}
                      <br />
                      <Moment format="Do MMM YYYY">{journal.date}</Moment>
                    </h5>
                    {journal?.shifts?.map((item, index) => {
                      return (
                        <li
                          style={
                            item._id === clientJournal._id ? activeTab : {}
                          }
                          key={index}
                          onClick={() => {
                            setClientJournal(item);
                          }}
                        >
                          <NavLink to="#" className="mb-0">
                            {/* <img alt="" src={item?.careTeamId[0]?.image} /> */}
                            <div className="body">
                              <p style={{ color: "#BB6BD9" }}>
                                {item?.startingTime} - {item?.endingTime}
                              </p>
                              <p>Shift Summary</p>
                              <MdArrowRight className="arrowIcon" />
                            </div>
                          </NavLink>
                        </li>
                      );
                    })}
                  </Fragment>
                );
              })}
            {loading === false && journalData?.length === 0 && (
              <p>No Shift Available</p>
            )}
          </ul>
        </div>
        {Object.keys(clientJournal)?.length !== 0 && (
          <JournalDetails
            clientJournal={clientJournal}
            setRefreshData={setRefreshData}
            clientData={clientData}
          />
        )}
      </div>
    </>
  );
};

export default ClientJournalPortal;

function groupJournalDataByDate(shiftdata) {
  if (shiftdata?.length < 1) {
    return [];
  }
  const grouped = {};
  shiftdata?.forEach((item) => {
    const dateLabel = new Date(item.Date).toDateString();

    if (!grouped[dateLabel]) {
      grouped[dateLabel] = [];
    }
    grouped[dateLabel].push(item);
  });

  return Object.keys(grouped).map((date) => ({
    date,
    shifts: grouped[date],
  }));
}
